import React, {useEffect} from 'react';
import { Box } from '@material-ui/core';
import useConfig from './JsonConfig';
import {getConfig} from "../Config";

const Environment = () => {
	const config = useConfig();

    // Should be 'dev' or 'test'
    const env = getConfig().environmentName || config.environmentName;

    // Sets window.environment for DEV and TEST logging
    useEffect(() => {
        if (!env) return;
        // @ts-ignore
        window.env = env;
    }, [config]);

	return (
		<>
			{config.environmentName && ( // only 'test'
			<Box color="white" bgcolor={config.environmentColor} position="absolute" zIndex="9999"
				 fontSize={{ xs: '10px', sm: '12px', md: '14px' }} paddingLeft="2rem"
				 paddingRight="2rem" letterSpacing="0.2rem" fontWeight="bold">
                {`! ${`${env} `.toUpperCase().repeat(6).trim()} !`}
			</Box>)}
		</>
	);
};

export default Environment